<template>
  <div :class="fullscreen ? 'ss_loading-fullScreen' : 'ss_loading'"
    :style="{
      zIndex: 20,
      background: background,
      color: color
    }">
    <div class="ss_loading__box">
      <div>S</div>
      <div>H</div>
      <div>O</div>
      <div>P</div>
      <div>S</div>
      <div>H</div>
      <div>O</div>
      <div>P</div>
      <div>S</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      fullscreen: true,
      background: 'rgba(0, 0, 0, .6)',
      color: '#ffffff'
    }
  },
  mounted() {
    if (this.fullscreen) {
      document.body.style.overflow = "hidden";
    }
  },
  destroyed() {
    document.body.style.overflowX = "hidden";
  },
}
</script>
<style lang="less" scoped>
@keyframes pulse {
  0% {
    transform: rotateX(0deg);
    transform-origin: 0 4vw;
  }
  100% {
    transform: rotateX(360deg);
    transform-origin: 0 4vw;
  }
}
.ss_loading_block() {
  z-index: 20;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ss_loading {
  .ss_loading_block();
  position: absolute;
  width: 375px;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  &-fullScreen {
    .ss_loading_block();
    position: fixed;
    width: 100vw;
    height: 100vh;
  }
  &__box {
    width: 200px;
    border-bottom: 2.5px solid #ffffff;
    display: flex;
    justify-content: space-around;
    >div {
      font-size: 18px;
      color: #ffffff;
      transform-style: preserve-3d;
      &:nth-child(1) {
        animation: pulse 3s infinite;
        animation-delay: 0ms;
      }
      &:nth-child(2) {
        animation: pulse 3s infinite;
        animation-delay: 200ms;
      }
      &:nth-child(3) {
        animation: pulse 3s infinite;
        animation-delay: 400ms;
      }
      &:nth-child(4) {
        animation: pulse 3s infinite;
        animation-delay: 600ms;
      }
      &:nth-child(5) {
        animation: pulse 3s infinite;
        animation-delay: 800ms;
      }
      &:nth-child(6) {
        animation: pulse 3s infinite;
        animation-delay: 1000ms;
      }
      &:nth-child(7) {
        animation: pulse 3s infinite;
        animation-delay: 1200ms;
      }
      &:nth-child(8) {
        animation: pulse 3s infinite;
        animation-delay: 1400ms;
      }
    }
  }
}
</style>